const SDK_URL = 'https://sdk.mercadopago.com/js/v2'

// Module level on purpose: App.vue keys the router-view on $route.fullPath, so
// switching ?experience= remounts the whole view. Caching the promise keeps the
// script tag from being injected once per mount.
let sdkPromise = null

/**
 * Load MercadoPago.js V2 on demand.
 *
 * Mercado Pago requires the SDK to be served from their CDN (PCI scope and the
 * anti fraud fingerprint), so it is never bundled. Loading it here instead of
 * from index.html keeps it off the other twelve routes and turns a CDN failure
 * into a message we can show, rather than a dead form.
 */
const loadMercadopagoSdk = () => {
  if (window.MercadoPago) {
    return Promise.resolve(window.MercadoPago)
  }
  if (sdkPromise) {
    return sdkPromise
  }
  sdkPromise = new Promise((resolve, reject) => {
    const script = document.createElement('script')
    script.src = SDK_URL
    script.async = true
    script.onload = () => {
      if (window.MercadoPago) {
        resolve(window.MercadoPago)
        return
      }
      sdkPromise = null
      reject(new Error('No pudimos cargar el formulario de pago. Recarga la página.'))
    }
    script.onerror = () => {
      sdkPromise = null
      script.remove()
      reject(new Error('No pudimos cargar el formulario de pago. Recarga la página.'))
    }
    document.head.appendChild(script)
  })
  return sdkPromise
}

export default {
  data: () => ({
    mp: null
  }),
  methods: {
    async initMercadopago (publicKey) {
      if (!publicKey) {
        throw new Error('Mercado Pago no está disponible para esta cuenta.')
      }
      const MercadoPago = await loadMercadopagoSdk()
      // advancedFraudPrevention stays on (the V2 default): the SDK attaches the
      // device fingerprint to the token by itself. Forwarding an explicit
      // Device ID to our API is tracked separately.
      this.mp = new MercadoPago(publicKey, { locale: 'es-CL' })
      return this.mp
    }
  }
}

export { loadMercadopagoSdk }
